<template lang="pug">
  .base-text
    slot
</template>

<script>
export default {
  name: 'BaseText',
};
</script>

<style lang="scss">
 .base-text {
   width: 100%;
   box-sizing: border-box;
   background: rgba(235, 239, 242, 0.5);
   border-radius: 6px;
   font-weight: 300;
   font-size: 14px;
   line-height: 18px;
   color: #1E3147;
   padding: 20px 16px;
   overflow-wrap: break-word;
   word-break: break-word;

   pre {
     white-space: pre-wrap
   }

   a {
     color: #2B69BE !important;
     text-decoration: underline;
   }

   strong {
     font-weight: bold;
   }

   ol {
     list-style: none;
     counter-reset: base-text-counter;
     display: flex;
     flex-wrap: wrap;
     margin: 6px 0 10px 45px;
     padding: 0;

     li {
       counter-increment: base-text-counter;
       width: 100%;
       margin-bottom: 0.5em;

       &:before {
         width: 25px;
         margin: 0 20px 0 -45px !important;
         float: left;
         content: counter(base-text-counter);
         text-align: right;
         color: #33A1FB;
         font-weight: bold;
       }
     }
   }

   ul {
     list-style: none;
     display: flex;
     flex-wrap: wrap;
     padding: 0;
     margin: 6px 0 10px 45px;

     li {
       counter-increment: base-text-counter;
       width: 100%;
       margin-bottom: 0.5em;

       &:before {
         width: 25px;
         margin: 5px 0 0 -45px;
         float: left;
         text-align: right;
         content: '\2022';
         flex-basis: 25px;
         flex-shrink: 0;
         color: #33A1FB;
         font-weight: bold;
         font-size: 20px;
         line-height: .5;
       }
     }
   }

   blockquote {
     display: block;
     border-radius: 6px;
     padding: 16px 15px 16px 28px;
     background-color: var(--color-orange-bg);
     font-family: "Geometria", sans-serif;
     line-height: 15px;
     color: var(--color-dark-gray);
     font-weight: 500;
     font-size: 13px;
     margin-bottom: 10px;
   }

   pre {
     position: relative;
     display: block;
     padding: 16px 15px 18px 28px;
     border-radius: 6px;
     background-color: var(--color-purple);
     font-family: "Geometria", sans-serif;
     font-style: normal;
     color: var(--color-dark-gray);
     font-weight: 500;
     font-size: 13px;
     left: -1px;
   }
  }
</style>
